/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PatternRedirector_route$ref = any;
export type routeRoutes_PatternRedirector_QueryVariables = {|
  routeId: string,
  date: string,
|};
export type routeRoutes_PatternRedirector_QueryResponse = {|
  +route: ?{|
    +$fragmentRefs: PatternRedirector_route$ref
  |}
|};
export type routeRoutes_PatternRedirector_Query = {|
  variables: routeRoutes_PatternRedirector_QueryVariables,
  response: routeRoutes_PatternRedirector_QueryResponse,
|};
*/


/*
query routeRoutes_PatternRedirector_Query(
  $routeId: String!
  $date: String!
) {
  route(id: $routeId) {
    ...PatternRedirector_route_19b1FI
    id
  }
}

fragment PatternRedirector_route_19b1FI on Route {
  patterns {
    code
    trips: tripsForDate(serviceDate: $date) {
      gtfsId
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routeId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "routeRoutes_PatternRedirector_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "date",
                "variableName": "date"
              }
            ],
            "kind": "FragmentSpread",
            "name": "PatternRedirector_route"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "routeRoutes_PatternRedirector_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Pattern",
            "kind": "LinkedField",
            "name": "patterns",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": "trips",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "date"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gtfsId",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5c48482f3cc062d65f064c1c5ff34762",
    "id": null,
    "metadata": {},
    "name": "routeRoutes_PatternRedirector_Query",
    "operationKind": "query",
    "text": "query routeRoutes_PatternRedirector_Query(\n  $routeId: String!\n  $date: String!\n) {\n  route(id: $routeId) {\n    ...PatternRedirector_route_19b1FI\n    id\n  }\n}\n\nfragment PatternRedirector_route_19b1FI on Route {\n  patterns {\n    code\n    trips: tripsForDate(serviceDate: $date) {\n      gtfsId\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1de1ec4e096530c00f8dbcacce118951';

module.exports = node;
